import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

export default function AdminTechnicians() {
    const [techs, setTechs] = useState([]);
    const load = () => api.get("/technicians").then(({ data }) => setTechs(data));
    useEffect(() => {
        load();
    }, []);

    const updateKyc = async (id, status) => {
        try {
            await api.post(`/technicians/${id}/kyc`, { status });
            toast.success(`KYC ${status}`);
            load();
        } catch (e) {
            toast.error("Failed");
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <div className="lx-label text-[#D4AF37] mb-2">Workforce</div>
                <h1 className="font-serif text-4xl text-white">Technicians</h1>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {techs.map((t) => (
                    <div
                        key={t.id}
                        className="lx-card-dark p-6"
                        data-testid={`tech-card-${t.id}`}
                    >
                        <div className="flex items-center gap-3 mb-4">
                            <div className="w-12 h-12 bg-[#2B1438] overflow-hidden rounded-full">
                                {t.avatar_url && (
                                    <img
                                        src={t.avatar_url}
                                        alt=""
                                        className="w-full h-full object-cover"
                                    />
                                )}
                            </div>
                            <div className="min-w-0 flex-1">
                                <div className="font-serif text-lg text-white truncate">
                                    {t.name}
                                </div>
                                <div className="text-xs text-white/60">{t.base_city}</div>
                            </div>
                            <span
                                className="text-[10px] uppercase tracking-wider px-2 py-1 border"
                                style={{
                                    color: t.available ? "#34C759" : "#A09BA5",
                                    borderColor: t.available ? "#34C75940" : "#A09BA540",
                                }}
                            >
                                ● {t.available ? "Online" : "Offline"}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 gap-3 mb-4 text-center">
                            <Stat label="Rating" value={`★ ${t.rating_avg?.toFixed(1)}`} />
                            <Stat label="Jobs" value={t.completed_jobs} />
                        </div>
                        <div className="lx-label text-[#A09BA5] mb-2">
                            KYC: <span className="text-[#D4AF37]">{t.kyc_status}</span>
                        </div>
                        {t.kyc_status !== "approved" && (
                            <button
                                onClick={() => updateKyc(t.id, "approved")}
                                data-testid={`approve-kyc-${t.id}`}
                                className="lx-btn-gold w-full py-2 text-xs"
                            >
                                Approve KYC
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="bg-[#180A21] py-2">
            <div className="text-xs text-white/60">{label}</div>
            <div className="text-sm text-white font-serif">{value}</div>
        </div>
    );
}
